// Tickets this Sentinel is acting on right now (Assign to me, or a Send that claims an unowned
// ticket). The server announces the resulting ownership like any other assignment, and its event
// can arrive before the request's own response, so the ticket is marked before the request
// goes out. The notification hook skips an "assigned" arrival for a marked ticket: nobody needs
// a toast and a ding for the ticket they just took.

/** Long enough for the request and its socket event, short enough to never hide a later one. */
const OWN_ACTION_WINDOW_MS = 15_000;

const ownActions = new Map<number, number>();

export function markOwnTicketAction(ticketId: number): void {
  ownActions.set(ticketId, Date.now() + OWN_ACTION_WINDOW_MS);
}

/** Whether the Sentinel is acting on this ticket right now. Expired marks are dropped. */
export function isOwnTicketAction(ticketId: number): boolean {
  const until = ownActions.get(ticketId);
  if (until === undefined) return false;
  if (until < Date.now()) {
    ownActions.delete(ticketId);
    return false;
  }
  return true;
}
